<template>
    <div class="water_diagram">
        <div class="water_diagram_box">
            <div class="water_diagram_box_main" id="main" ref="main">
                <div
                    id="canvas"
                    ref="canvas"
                    class="canvas-wrap"
                    :style="
                        `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                    "
                >
                    <img
                        class="bg-img"
                        src="../../../assets/image/diagram/water_diagram.png"
                        alt
                        srcset
                    />
                    <div
                        v-for="item in datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                    >
                        <div class="data-box">
                            <div class="data-box-name">日</div>
                            <div class="data-box-data">
                                {{ item.day_power }}吨
                            </div>
                        </div>
                        <div class="data-box">
                            <div class="data-box-name">月</div>
                            <div class="data-box-data">
                                {{ item.month_power }}吨
                            </div>
                        </div>
                        <div class="data-box">
                            <div class="data-box-name">年</div>
                            <div class="data-box-data">
                                {{ item.year_power }}吨
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
export default {
    data() {
        return {
            left: "0",
            top: "-260",
            scale: 0.7,
            timer: null,
            datas: [
                {
                    point_id: "1572157460025565184",
                    name: "总水表",
                    top: 25,
                    left: 45.4,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572157667471646720",
                    name: "1#自来水箱进水表 南",
                    top: 48,
                    left: 13.3,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572157854927675392",
                    name: "2#自来水箱进水表 南",
                    top: 48,
                    left: 31,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572158169907322880",
                    name: "1#消防水箱进水表 北",
                    top: 48,
                    left: 54,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572158233723658240",
                    name: "2#消防水箱进水表 北",
                    top: 48,
                    left: 70,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572156455510728704",
                    name: "码头东侧",
                    top: 85,
                    left: 10,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572156685467639808",
                    name: "船舶加水表2",
                    top: 85,
                    left: 20,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572156747211988992",
                    name: "船舶加水表3",
                    top: 85,
                    left: 30,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572156818787786752",
                    name: "船舶加水表4",
                    top: 85,
                    left: 40,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572156882948055040",
                    name: "船舶加水表5",
                    top: 85,
                    left: 50,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572156940573597696",
                    name: "船舶加水表6",
                    top: 85,
                    left: 60,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572157033779421184",
                    name: "船舶加水表7",
                    top: 85,
                    left: 70,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                },
                {
                    point_id: "1572157109050400768",
                    name: "船舶加水表8",
                    top: 85,
                    left: 80,
                    day_power: "",
                    month_power: "",
                    year_power: ""
                }
            ]
        };
    },
    mounted() {
        this.zoom();
        this.drag();
        this.getData();
        this.setTimer();
        this.setImgSize();
        window.onresize = () => {
            this.setImgSize();
        };
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getData();
            }, 1000 * 60);
        },
        getData() {
            api.getWaterPowerMap().then(res => {
                let valueJson = res.bus_json;
                this.datas.forEach(item => {
                    let point = valueJson[item.point_id];
                    item.day_power = point.day_power;
                    item.month_power = point.month_power;
                    item.year_power = point.year_power;
                });
            });
        },
        setImgSize() {
            if (window.innerWidth >= 2560) {
                this.basisUnitH = 1.2;
                this.basisUnitV = 1.2;
            } else if (window.innerWidth < 2560 && window.innerWidth >= 1900) {
                this.basisUnitH = 1.0;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1920 && window.innerWidth >= 1660) {
                this.basisUnitH = 0.82;
                this.basisUnitV = 0.82;
            } else if (window.innerWidth < 1660 && window.innerWidth >= 1420) {
                this.basisUnitH = 0.7;
                this.basisUnitV = 0.7;
            } else if (window.innerWidth < 1420 && window.innerWidth >= 1320) {
                this.basisUnitH = 0.6;
                this.basisUnitV = 0.6;
            } else {
            }
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function(event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function(event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function(en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function(en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function() {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.water_diagram {
    width: 100%;
    height: 100%;
    color: #fff;
    padding: 0 2rem 0rem 2rem;
    padding-top: 0;
    box-sizing: border-box;
    position: relative;
    .water_diagram_box {
        margin: 0 auto;
        text-align: center;
        align-self: center;
        width: 100%;
        height: 100%;
        position: relative;
        .water_diagram_box_main {
            top: 0%;
            left: 0%;
            width: 100%;
            padding: 2rem 2rem 0 2rem;
            box-sizing: border-box;
            height: 100%;
            position: relative;
            overflow: hidden;
            cursor: move;
            .canvas-wrap {
                width: 100%;
                // min-height: 100%;
                // height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                box-sizing: border-box;

                .bg-img {
                    width: 100%;
                    height: 100%;
                }

                .data-wrap {
                    position: absolute;
                    color: #fff;
                    font-size: 1.2rem;
                    .data-box {
                        display: flex;
                        height: 2rem;
                        line-height: 2rem;
                        margin-bottom: 0.3rem;
                        .data-box-name {
                            color: #dbf743;
                            width: 2rem;
                        }
                        .data-box-data {
                            width: 8rem;
                            background: #111f45;
                            border-radius: 1rem;
                        }
                    }
                }
            }
        }
    }
}
</style>
